import type { RouteLogResponse } from '../../../../api/useFreight/useOrderRouteLog'
import type { AffectedTank, OrderByIdResponse, Tank } from '../../../../api/useOrders/responses'

/**
 * Converts route data from different sources into a standardized format for the map
 *
 * @param routeLogData - Route log data from the API
 * @param orderExtraData - Order data from the API
 * @returns An array of map coordinates
 */
export function getRouteStops(routeLogData?: RouteLogResponse) {
  // Use route data from routeLogData if available, otherwise fallback to map_stops
  return routeLogData?.route
    ? routeLogData.route.map((stop) => ({
        lat: stop.lat,
        lng: stop.lon,
      }))
    : []
}

/**
 * Creates a lookup map of tank volumes by tank ID
 *
 * @param affectedTanks - Array of affected tanks from order data
 * @returns A Map of tank IDs to formatted volume strings
 */
export function createTankVolumesMap(affectedTanks?: AffectedTank[]) {
  if (!affectedTanks || !affectedTanks[0]?.tanks) {
    return new Map()
  }

  return new Map(affectedTanks[0].tanks.map((tank: Tank) => [tank.tank_id, tank.current_volume.toLocaleString()]))
}
